import React, { useState, useEffect, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import { getUnavailableDeliveryLocations } from "./_requests";

const UndeliverableLocation = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    getUnavailableDeliveryLocations().then((res: any) => {
      // Assuming response is like { data: [...] } or just [...]
      // Adjust based on typical API response in this project (usually res.data)
      setData(res?.data || res || []);
    });
  }, []);

  const columns = useMemo(
    () => [
      {
        header: "S.No",
        accessorKey: "sno",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const { pageIndex, pageSize } = cell.table.getState().pagination;
          return pageIndex * pageSize + cell.row.index + 1;
        },
      },
      {
        header: "Name",
        accessorKey: "user.name", // Adjustment needed if backend sends different key
        enableColumnFilter: false,
      },
      {
        header: "Mobile Number",
        accessorKey: "user.mobile_number", // Adjustment needed if backend sends different key
        enableColumnFilter: false,
      },
      {
        header: "Location",
        accessorKey: "full_address", // Adjustment needed if backend sends different key
        enableColumnFilter: false,
      },
      {
        header: "Time",
        accessorKey: "created_at", // Adjustment needed if backend sends different key
        enableColumnFilter: false,
        cell: (cell: any) => {
          return new Date(cell.getValue()).toLocaleString();
        }
      },
    ],
    []
  );

  document.title = "Undeliverable Locations | Paal Dappa Admin";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Undeliverable Locations" pageTitle="Location" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">Undeliverable Locations List</h4>
                </CardHeader>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={data}
                    isGlobalFilter={true}
                    customPageSize={10}
                    divClass="table-responsive table-card mb-3"
                    tableClass="align-middle table-nowrap"
                    theadClass="table-light"
                    SearchPlaceholder="Search..."
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UndeliverableLocation;
